import React from 'react';
import PropTypes from 'prop-types';
import { Button, Modal } from '@getro/rombo';
import { Flex, Text } from 'rebass/styled-components';

const DisconnectLinkedinSync = ({ isSubmitting, onCancel, onConfirm }) => (
  <Modal
    title="Disconnect LinkedIn sync?"
    isOpen
    onCancel={onCancel}
    actions={
      <Flex justifyContent={['flex-end']}>
        <Button onClick={onCancel} variant="tertiary">
          Cancel
        </Button>
        <Button variant="danger" loading={isSubmitting} onClick={onConfirm}>
          Disconnect
        </Button>
      </Flex>
    }
  >
    <Text width="100%" mb={2}>
      Disconnecting LinkedIn will:
    </Text>
    <ul style={{ paddingLeft: '18px', marginTop: 0 }}>
      <li>
        <Text color="text.main">Stop syncing LinkedIn connections</Text>
      </li>
      <li>
        <Text color="text.main">
          Remove all contacts from networks they are being shared with (unless they&apos;ve been added in other ways)
        </Text>
      </li>
    </ul>
  </Modal>
);

DisconnectLinkedinSync.propTypes = {
  isSubmitting: PropTypes.bool,
  onCancel: PropTypes.func.isRequired,
  onConfirm: PropTypes.func.isRequired,
};

DisconnectLinkedinSync.defaultProps = {
  isSubmitting: false,
};

export default DisconnectLinkedinSync;
